import "./StrategicInquiries.module.css";
import Header from "@/reusable_sections/Header";
import ContactTheNight from "./sections/ContactTheNight";
import PortageCountyCraftsmanship from "./sections/PortageCountyCraftsmanship";
import Footer from "@/reusable_sections/Footer";
export default function StrategicInquiriesPage() {
  return <div>
      <Header />
      <ContactTheNight />
      <PortageCountyCraftsmanship />
      <Footer />
    </div>;
}